import { THEME } from './theme'
import type { ProjectileVisualDefinition } from './types'

export const PROJECTILE_VISUALS: Record<string, ProjectileVisualDefinition> = {
  fire: {
    id: 'fire',
    definitionId: 'fire',
    fill: THEME.projectileFire,
    silhouette: 'flare',
    radiusFactor: 0.13,
    kind: 'procedural'
  },
  frost: {
    id: 'frost',
    definitionId: 'frost',
    fill: THEME.projectileFrost,
    silhouette: 'crystal',
    radiusFactor: 0.12,
    kind: 'procedural'
  },
  cannon: {
    id: 'cannon',
    definitionId: 'cannon',
    fill: THEME.projectileCannon,
    silhouette: 'shell',
    radiusFactor: 0.18,
    kind: 'procedural'
  },
  poison: {
    id: 'poison',
    definitionId: 'poison',
    fill: THEME.projectilePoison,
    silhouette: 'droplet',
    radiusFactor: 0.12,
    kind: 'procedural'
  },
  aa: {
    id: 'aa',
    definitionId: 'aa',
    fill: THEME.projectileAa,
    silhouette: 'dart',
    radiusFactor: 0.11,
    kind: 'procedural'
  },
  mage: {
    id: 'mage',
    definitionId: 'mage',
    fill: THEME.projectileMage,
    silhouette: 'bolt',
    radiusFactor: 0.11,
    kind: 'procedural'
  }
}

export const FALLBACK_PROJECTILE_VISUAL: ProjectileVisualDefinition = {
  id: 'fallback-projectile',
  definitionId: 'fallback',
  fill: THEME.white,
  silhouette: 'fallback',
  radiusFactor: 0.12,
  kind: 'procedural'
}
